import { Button, MindyLogoDark, MindyLogoLight, useTheme } from '@quadminds/mindkit';
import { IAuthMeV2OutputDto } from '@quadminds/shared/auth-system';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useIsKnowledge } from '../../hooks/useIsKnowledge';
import { queryClient } from '../../main';

interface WelcomeSlideProps {
    onNext: () => void;
}

export const WelcomeSlide = ({ onNext }: WelcomeSlideProps) => {
    const { t } = useTranslation();
    const { theme } = useTheme();
    const { isKnowledge } = useIsKnowledge();
    const userInfo: IAuthMeV2OutputDto | undefined = queryClient.getQueryData(['userInfo']);

    return (
        <div className="p-8 flex flex-col flex-grow space-y-12 h-full justify-between text-center">
            <motion.div
                initial={{ scale: 0.7, opacity: 0, rotate: -10, y: 40, filter: 'blur(16px)' }}
                animate={{ scale: 1.08, opacity: 1, rotate: 0, y: 0, filter: 'blur(0px)' }}
                transition={{
                    delay: 0.1,
                    duration: 0.7,
                    type: 'spring',
                    stiffness: 140,
                    damping: 10,
                    mass: 0.7,
                }}
                whileHover={{ scale: 1.13, rotate: 2, filter: 'drop-shadow(0 4px 24px #7b61ff88)' }}
                whileTap={{ scale: 0.98, rotate: -2 }}
                className="flex justify-center mx-auto"
            >
                <motion.img
                    src={theme === 'dark' ? MindyLogoLight : MindyLogoDark}
                    alt="Mindy"
                    className="h-12 cursor-pointer transition-shadow"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5, duration: 0.6 }}
                />
            </motion.div>
            <div>
                <h1 className="text-3xl font-bold mb-2">
                    {t('onboarding.welcome.title', { name: userInfo?.firstName || 'User' })}
                </h1>
                <p className="text-gray-qm-500 dark:text-gray-qm-400 mb-6">
                    {t(isKnowledge ? 'onboarding.welcome.subtitleKnowledge' : 'onboarding.welcome.subtitle')}
                </p>
            </div>
            <Button onClick={onNext} className="w-full">
                {t('onboarding.welcome.cta')}
            </Button>
        </div>
    );
};
